import Card from "@rio-cloud/rio-uikit/Card";
import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

const TITLE_ROW_HEIGHT = 24;
const CHART_HEIGHT = 400;
const X_AXIS_HEIGHT = 24;
const LEGEND_HEIGHT = 46;
const PLOT_HEIGHT = CHART_HEIGHT - X_AXIS_HEIGHT - LEGEND_HEIGHT;
const ABOVE_BASELINE = 220;
const BELOW_BASELINE = PLOT_HEIGHT - ABOVE_BASELINE;
const Y_AXIS_WIDTH = 100;
const BAR_SIZE = 28;

const Y_AXIS_TICKS = [0, 1, 2, 3, 4, 5, 6];

interface SkeletonBar {
  key: string;
  revenue: number;
  expenses: number;
}

const BAR_HEIGHTS: SkeletonBar[] = [
  { key: "financial-evolution-bar-1", revenue: 62, expenses: 45 },
  { key: "financial-evolution-bar-2", revenue: 70, expenses: 52 },
  { key: "financial-evolution-bar-3", revenue: 55, expenses: 40 },
  { key: "financial-evolution-bar-4", revenue: 80, expenses: 58 },
  { key: "financial-evolution-bar-5", revenue: 66, expenses: 48 },
  { key: "financial-evolution-bar-6", revenue: 74, expenses: 60 },
  { key: "financial-evolution-bar-7", revenue: 58, expenses: 42 },
  { key: "financial-evolution-bar-8", revenue: 85, expenses: 63 },
  { key: "financial-evolution-bar-9", revenue: 72, expenses: 50 },
  { key: "financial-evolution-bar-10", revenue: 64, expenses: 46 },
  { key: "financial-evolution-bar-11", revenue: 78, expenses: 56 },
  { key: "financial-evolution-bar-12", revenue: 68, expenses: 51 },
];

const LEGEND_ITEMS = [0, 1, 2];

export default function FinancialEvolutionChartSkeleton() {
  const toPixels = (percentage: number, available: number) => Math.round((percentage / 100) * available);

  return (
    <Card className="padding-y-25 padding-x-15 padding-x-50-md margin-bottom-20">
      <div
        className="display-flex align-items-center justify-content-between gap-10 padding-bottom-20"
        style={{ minHeight: TITLE_ROW_HEIGHT + 20 }}
      >
        <ContentLoader height={16} width={180} />
      </div>

      <div className="overflow-x-auto">
        <div className="width-700 width-100pct-md">
          <div className="display-flex flex-column" style={{ height: CHART_HEIGHT }}>
            <div className="display-flex" style={{ height: PLOT_HEIGHT }}>
              <div
                className="display-flex flex-column justify-content-between"
                style={{ width: Y_AXIS_WIDTH, alignItems: "flex-end", flexShrink: 0 }}
              >
                {Y_AXIS_TICKS.map((tick) => (
                  <ContentLoader key={tick} height={12} width={80} />
                ))}
              </div>

              <div className="display-flex" style={{ flex: 1, justifyContent: "space-around" }}>
                {BAR_HEIGHTS.map((bar) => (
                  <div key={bar.key} className="display-flex flex-column" style={{ width: BAR_SIZE, flexShrink: 0 }}>
                    <div className="display-flex" style={{ height: ABOVE_BASELINE, alignItems: "flex-end" }}>
                      <ContentLoader height={toPixels(bar.revenue, ABOVE_BASELINE)} width={BAR_SIZE} />
                    </div>
                    <div style={{ height: BELOW_BASELINE }}>
                      <ContentLoader height={toPixels(bar.expenses, BELOW_BASELINE)} width={BAR_SIZE} />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="display-flex align-items-center"
              style={{ height: X_AXIS_HEIGHT, paddingLeft: Y_AXIS_WIDTH, justifyContent: "space-around" }}
            >
              {BAR_HEIGHTS.map((bar) => (
                <ContentLoader key={bar.key} height={12} width={40} />
              ))}
            </div>

            <div
              className="display-flex align-items-center gap-20"
              style={{ height: LEGEND_HEIGHT, justifyContent: "flex-end" }}
            >
              {LEGEND_ITEMS.map((item) => (
                <ContentLoader key={item} height={12} width={80} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
